const getRequestState = state => state.merge({ loading: true, error: null });

export default { getRequestState };
